module.exports = __webpack_public_path__ + "static/media/search_icon_black.b68991c6.svg";